export default "__VITE_ASSET__Dgok69D8__"